import { render, staticRenderFns } from "./FPFFooter.vue?vue&type=template&id=7b49eaaa"
import script from "./FPFFooter.vue?vue&type=script&lang=js"
export * from "./FPFFooter.vue?vue&type=script&lang=js"
import style0 from "./FPFFooter.vue?vue&type=style&index=0&id=7b49eaaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports